
function submitSearch(){

    $('form.search-bar').submit();
}

var __isp_options = {

    isp_serp_with_product_attributes : '1',
    isp_dropdown_open_callback: function(){
    // Add view more button in dropdown
    if($('a.view_more_button').length == 0){
    $('li[isp_product]:last').after('<li class="view_more"><a class="view_more_button">View More</a></li>');
    $('a.view_more_button').attr('onclick','submitSearch();');

    }
    else{
      $('li.view_more').insertAfter($('li[isp_product]:last'));


    }
    },
    isp_serp_callback: function () {
    // Add In stock & shipping texts
    if($jquery_isp('div.isp_custom_info').length == 0){
    $('li.isp_grid_product').each(function(){
                let product_id =  $(this).attr('product_id');
                $jquery_isp(this).find('.isp_product_quick_view_buttoniew_button').insertAfter($(this).find('.isp_product_price_wrapper'));
                $jquery_isp(this).append('<div class="isp_custom_info"><span class="isp_availiblity in_stock">In Stock</span><span> <i class="fa fa-truck"></i>  Ships within 24 hours</span></div>');
                $jquery_isp(this).find('div.isp_custom_info').insertAfter($(this).find('.isp_product_price_wrapper'));
                
                // Set In Stock text and class if out of stock
                if(ISP_PRODUCTS[product_id].vra){
                    let sellableVariants = ISP_PRODUCTS[product_id].vra.filter(a => {
                        return a[1].find(b => {
                            return b[0] === "Sellable" && b[1][0];
                        });
                        
                    });
                    if(sellableVariants.length == 0){
                        $jquery_isp(this).find('span.isp_availiblity').removeClass('in_stock');
                        $jquery_isp(this).find('span.isp_availiblity').text('Out of Stock');
                    }
                }

        });
    
    // Set Quick view to MORE INFO
    $jquery_isp('.isp_product_quick_view_button').text('MORE INFO');
  
  
    // Set Add to Cart button as plus icon
    $jquery_isp('form.isp_add_to_cart_form').append('<span class="plus_icon">+</span>');
  
    }
      
    // Add "Product Filter" title to horizontal filters
    if($jquery_isp('span.facet_filter_title').length == 0){
    $jquery_isp('div.isp_left_container.horizontal').prepend('<span class="facet_filter_title">Product Filter</span>');
    }
  

    // Click on Add to Cart input in plus icon is clicked
    $jquery_isp('span.plus_icon').click(function(){
        $(this).parents('.isp_grid_product').find('.isp_product_image_href').click();
        });
     
    // Choose facet value when checkbox is clicked
    $jquery_isp('.isp_facet_value').click(function(){ $jquery_isp(this).find('a').click();});
      
      
    // Set filters title to be just before the refine button on mobile
  	if($('#isp_refine_nevigation').css('display') !== 'none'){
      
    	$('.isp_center_container_header').prepend($('.facet_filter_title'));
      if($('.facet_filter_title').length == 0){
        $('.isp_center_container_header').prepend('<span class="facet_filter_title">Product Filter</span>');
      }
	}
  
	// Set refine button text
	$('#isp_refine_nevigation').text('REFINE BY');
      
    }

};
    